<div class="story-posts-container">
  <app-post-list
    [posts]="storyPosts"
    [loading]="storyPostsLoading"
    [feed]="null"
    [viewMode]="localViewMode"
    [user]="user"
    [showPagination]="true"
    [currentPage]="storyPostsCurrentPage"
    [itemsPerPage]="storyPostsItemsPerPage"
    [totalItemsCount]="storyPostsTotalCount"
    (pageChanged)="onStoryPostsPageChanged($event)"
    (itemsPerPageChanged)="onStoryPostsItemsPerPageChanged($event)"
    [disableTools]="true"
    [isStoryMode]="false"
    [customRemovePost]="removeStoryPost"
    [viewConfig]="localViewConfig"
    [showAdvancedSearch]="false"
  >
    <div postListToolbar class="story-posts-toolbar-wrapper">
      <sui-toolbar #tb>
        <!-- Search -->
        <app-search-input
          [placeholder]="'feed-actions.placeholder.search' | translate"
          [value]="searchQuery"
          (inputChanged)="onSearchChanged($event)"
        ></app-search-input>

        <!-- View (toggles / radios) -->
        <sui-button
          class="right-group-start"
          variant="ghost"
          [leadingIcon]="['fas', 'eye']"
          [trailingIcon]="['fas', 'caret-down']"
          [iconOnly]="tb.collapsed()"
          [ariaLabel]="
            tb.collapsed()
              ? ('feed-actions.button.view' | translate)
              : undefined
          "
          [suiTooltip]="
            tb.collapsed()
              ? ('feed-actions.button.view' | translate)
              : ('feed-actions.button.view-tooltip' | translate)
          "
          [suiPopoverTrigger]="viewPanel"
          suiPopoverPlacement="bottom-end"
          [suiPopoverContainer]="popoverContainer()"
          #viewTrigger="suiPopoverTrigger"
          [expanded]="viewTrigger.isOpen()"
        >
          {{ tb.collapsed() ? "" : ("feed-actions.button.view" | translate) }}
        </sui-button>
        <ng-template #viewPanel>
          <div suiPopover class="dropdown-menu view-dropdown-menu">
            @if (tb.collapsed()) {
              <div class="dropdown-heading">
                {{ "feed-actions.button.view" | translate }}
              </div>
            }
            @for (group of viewGroups; track group) {
              @if (group.radioGroup) {
                <div
                  sui-radio-group
                  orientation="vertical"
                  [ngModel]="group.value"
                  [ngModelOptions]="{ standalone: true }"
                  (valueChange)="onViewRadioChange(group, $event)"
                >
                  @for (item of group.items; track item) {
                    <sui-radio
                      class="dropdown-item"
                      indicatorPosition="trailing"
                      [value]="item.value"
                    >
                      @if (item.icon) {
                        <fa-icon [icon]="item.icon"></fa-icon>
                      }
                      <span>{{ item.text }}</span>
                    </sui-radio>
                  }
                </div>
              } @else {
                @for (item of group.items; track item) {
                  @if (item.isSeparator) {
                    <div class="dropdown-divider"></div>
                  }
                  @if (item.isTitle) {
                    <div class="dropdown-heading">
                      {{ item.text }}
                    </div>
                  }
                  @if (!item.isSeparator && !item.isTitle) {
                    <sui-checkbox
                      class="dropdown-item"
                      indicatorPosition="trailing"
                      [checked]="!!item.isSelected"
                      (checkedChange)="item.action?.()"
                    >
                      @if (item.icon) {
                        <fa-icon [icon]="item.icon"></fa-icon>
                      }
                      <span>{{ item.text }}</span>
                    </sui-checkbox>
                  }
                }
              }
            }
          </div>
        </ng-template>

        <!-- Sort (field radios + order radios) -->
        <sui-button
          variant="ghost"
          [leadingIcon]="
            sortDirection === 'asc'
              ? ['fas', 'arrow-up-a-z']
              : ['fas', 'arrow-down-z-a']
          "
          [trailingIcon]="['fas', 'caret-down']"
          [iconOnly]="tb.collapsed()"
          [ariaLabel]="
            tb.collapsed()
              ? ('feed-actions.button.sort' | translate)
              : undefined
          "
          [suiTooltip]="
            tb.collapsed()
              ? ('feed-actions.button.sort' | translate)
              : ('feed-actions.button.sort-tooltip' | translate)
          "
          [suiPopoverTrigger]="sortPanel"
          suiPopoverPlacement="bottom-end"
          [suiPopoverContainer]="popoverContainer()"
          #sortTrigger="suiPopoverTrigger"
          [expanded]="sortTrigger.isOpen()"
        >
          {{ tb.collapsed() ? "" : ("feed-actions.button.sort" | translate) }}
        </sui-button>
        <ng-template #sortPanel>
          <div suiPopover class="dropdown-menu">
            @if (tb.collapsed()) {
              <div class="dropdown-heading">
                {{ "feed-actions.button.sort" | translate }}
              </div>
            }
            <div
              sui-radio-group
              orientation="vertical"
              [ngModel]="sortField"
              [ngModelOptions]="{ standalone: true }"
              (valueChange)="onSortFieldChange($any($event))"
            >
              @for (item of sortFieldItems; track item) {
                <sui-radio
                  class="dropdown-item"
                  indicatorPosition="trailing"
                  [value]="item.value"
                >
                  @if (item.icon) {
                    <fa-icon [icon]="item.icon"></fa-icon>
                  }
                  <span>{{ item.text }}</span>
                </sui-radio>
              }
            </div>
            <div class="dropdown-divider"></div>
            <div
              sui-radio-group
              orientation="vertical"
              [ngModel]="sortDirection"
              [ngModelOptions]="{ standalone: true }"
              (valueChange)="onSortOrderChange($any($event))"
            >
              @for (item of sortOrderItems; track item) {
                <sui-radio
                  class="dropdown-item"
                  indicatorPosition="trailing"
                  [value]="item.value"
                >
                  @if (item.icon) {
                    <fa-icon [icon]="item.icon"></fa-icon>
                  }
                  <span>{{ item.text }}</span>
                </sui-radio>
              }
            </div>
          </div>
        </ng-template>
      </sui-toolbar>
    </div>
  </app-post-list>
</div>
